// extracted by mini-css-extract-plugin
module.exports = {"pokeBody":"App_pokeBody__1SpkD","poke":"App_poke__2lcst","pokeBtn":"App_pokeBtn__3G_Bv","loading":"App_loading__3AfxY"};